import type { ExternalTableSchema } from '@packages/table-builder';

export const systemRolesTable: ExternalTableSchema = {
  metadata: {
    title: 'System Roles',
    entity: 'system-role',
  },
  dataSource: {
    endpoint: '/api/customer/api/app/customer-role/customer-role',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    requestParams: {
      SelectedPermissions: 'filters.selectedPermissions',
    },
  },
  columns: [
    {
      field: 'roleName',
      header: 'Role Names',
      type: 'modal',
      width: 180,
      sortable: true,
      fields: { id: 'id' },
      modal: { popoverInfo: { kind: 'Role' } },
    },
    { field: 'description', header: 'Description', type: 'text', width: 180 },
    {
      field: 'numberOfUsers',
      header: 'No. of Users',
      type: 'modal',
      width: 180,
      sortable: true,
      fields: { id: 'id' },
      modal: { popoverInfo: { kind: 'User' }, enableTag: true },
    },
    {
      field: 'isEnabled',
      header: 'Role Status',
      type: 'badge',
      width: 180,
      align: 'center',
      visibility: 'picker',
      conditionalValues: { true: 'ACTIVE', false: 'INACTIVE' },
      badge: { statusMap: { ACTIVE: 'success', INACTIVE: 'error' } },
    },
    {
      field: 'creationTime',
      header: 'Role Created Date',
      type: 'date',
      width: 180,
      visibility: 'picker',
    },
  ],
  actions: {
    toolbar: {
      buttons: [
        { id: 'ADD_SYSTEM_ROLE', label: 'Add Role', icon: 'add_circle_outline', variant: 'primary' },
        {
          id: 'BULK_EDIT_SYSTEM_ROLES',
          label: 'Bulk Edit',
          icon: 'discover_tune',
          variant: 'primary-outline',
          requiresSelection: true,
        },
      ],
    },
    row: [
      { id: 'VIEW_SYSTEM_ROLE', label: 'View' },
      { id: 'EDIT_SYSTEM_ROLE', label: 'Edit' },
      { id: 'COPY_SYSTEM_ROLE', label: 'Copy' },
      { id: 'DELETE_SYSTEM_ROLE', label: 'Delete', variant: 'danger' },
    ],
  },
  features: {
    search: { enabled: true, placeholder: 'Search' },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    selection: { keyField: 'id' },
    columnPreferences: { persistenceKey: 'System Roles', resizable: true, reorderable: true },
  },
};
